import React from "react";
import PropTypes from "prop-types";

/**
 * Formularz merchanta - dane autoryzacyjne
 */
class P24MerchantAuthForm extends React.Component {

    handleSubmit = e => {
        e.preventDefault();
        this.props.onSubmit();
    };

    render() {
        return (
            <div className="w3-card-4">
                <div className="w3-container w3-theme">
                    <h2 className="w3-center">{this.props.title}</h2>
                </div>

                <div className="w3-container">
                    <p>Poniższe danę służą do komunikacji z systemem Przelewy24 poprzez API REST/SOAP.</p>
                </div>

                <br />
                <div className="w3-row-padding">
                    <div className="w3-col s12">
                        {this.props.children}
                    </div>
                </div>

                <form className="w3-container" onSubmit={this.handleSubmit}>

                    <div className="w3-bar">
                        <button
                            className="w3-btn w3-theme-light w3-bar-item w3-right w3-margin-right"
                            type="submit"
                        >
                            {this.props.submitText}
                        </button>
                    </div>
                </form>

            </div>
        )
    }
}

//ustawienie domyslnych pol
P24MerchantAuthForm.defaultProps = {
    title: "Aktualizacja klucza merchanta",
    submitText: "Zamknij"
}

P24MerchantAuthForm.propTypes = {
    //tytul formularza
    title: PropTypes.string.isRequired,
    //akcja zwrotna na zamknij
    onSubmit: PropTypes.func.isRequired,
    //tekst na akcji zamknij
    submitText: PropTypes.string.isRequired
}

export default P24MerchantAuthForm